import React, { Children, cloneElement, isValidElement, useCallback, useReducer, useRef } from 'react'
import styles from './SimpleDetails.module.css'
import { useResize } from 'hooks/useResize'

function childrenDetailsReducer (state, { parentWidth, newChildWidth, childIndex }) {
  let rowWidthSum = 0
  return state.map(item => {
    const isCurrentItem = item.id === childIndex
    rowWidthSum += isCurrentItem ? newChildWidth : item.width
    const isFirstElementInRow = rowWidthSum > parentWidth
    if (isFirstElementInRow) rowWidthSum = newChildWidth

    return {
      id: item.id,
      width: isCurrentItem ? newChildWidth : item.width,
      isFirstElementInRow: isFirstElementInRow
    }
  })
}

function mapInitialValues (children) {
  return children.map((_, index) => ({
    id: index,
    width: 0,
    isFirstElementInRow: false
  }))
}

export function DetailsRow ({ children }) {

  const [childrenDetails, setChildrenDetails] = useReducer(childrenDetailsReducer, mapInitialValues(children))
  const componentRef = useRef()
  const { width } = useResize(componentRef)

  const onChildWidthChange = useCallback((newWidth, childIndex) => {
    setChildrenDetails({ parentWidth: width, newChildWidth: newWidth, childIndex })
  }, [width])

  return (
    <div ref={componentRef}
         className={styles.contentRow}>
      {Children.map(children, (child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            onWidthChange: onChildWidthChange,
            index: index,
            isLastElementInRow: childrenDetails[index + 1]?.isFirstElementInRow
          })
        }
        return child
      })}</div>
  )
}
